import * as types from './types';

export const getUserBadges = (course) => (dispatch) => {
  dispatch({ type: types.GET_USER_BADGES, payload: course });
};

export const resetBadges = () => (dispatch) => {
  dispatch({ type: types.RESET_BADGES });
};